import { bpHistory } from 'global/bpHistory';
import { TabId } from './types';

export function isTabId(value: string): value is TabId {
  return Object.values(TabId).includes(value as TabId);
}

export function isAllowedTabId(value: string, allowedTabIds: readonly TabId[]): value is TabId {
  return isTabId(value) && allowedTabIds.includes(value);
}

export function syncSubscriberIdToUrl(subscriberId: string): void {
  const params = new URLSearchParams(bpHistory.location.search);
  params.set('subscriberId', subscriberId);
  bpHistory.replace({
    pathname: bpHistory.location.pathname,
    search: params.toString(),
  });
}
